import React from 'react';
import InformativeTooltip from '@panel/commons/lib/Tooltip/InformativeTooltip';
import { useTranslation } from 'react-i18next';
import { formatNumber } from '@panel/commons/helpers/formatAmount';
import {
  TableLayout,
  TableRow,
  TableData,
  NoData,
  RetryButton,
  Loading,
  LoadingContainer,
  PercentLabel,
  Headers,
  HeaderTooltipContainer,
  TooltipContent,
  TitlePriceByM2
} from './styles';

function ComparisonTable({ headers, rows, priceLoading, priceError, onReload, isMobile, comparisonType }) {
  const { t } = useTranslation();

  const hasHelper = ['visitsAndPrintsAvg', 'visitsInterestedAvg'];

  const getHeaderContent = (header, row) => {
    // se devuelve la traduccion si son titulos de row sino el valor
    if (header === 'difference')
      return row[header] ? (
        <PercentLabel score={row[header].score}>
          <div className='pill-wrapper' data-panel={`desempeno-table-pill-${row.titleRow}`}>
            <div />
            {formatNumber(row[header].value)}%
          </div>
        </PercentLabel>
      ) : (
        ''
      );
    if (header === 'titleRow' && row.titleRow !== 'priceByM2') return t(`panel.desempeno.table.${row[header]}`);
    if (header === 'titleRow' && row.titleRow === 'priceByM2')
      return (
        <TitlePriceByM2 isMobile={isMobile}>
          {t(`panel.desempeno.table.${row[header]}`)}
          <InformativeTooltip dataPanel='info-tooltip-priceByM2' backgroundColor='black' fixedPosition='top'>
            {t('panel.desempeno.table.priceByM2.tooltip')}
          </InformativeTooltip>
        </TitlePriceByM2>
      );
    // se coloca distinto de null por que el 0 es un dato valido (falsy values)
    if (row[header] !== null) return row[header];
    return '-';
  };

  const getPriceStatusLabel = (header, row) => {
    if (priceLoading)
      return (
        <LoadingContainer>
          <Loading className='dot-flashing' />
        </LoadingContainer>
      );
    if (priceError) return <RetryButton onClick={onReload}>{t('panel.desempeno.retry.cargar')}</RetryButton>;
    if (!row[header]) return <NoData>{t('panel.desempeno.table.withoutData')}</NoData>;
    return row[header] !== null ? row[header] : '-';
  };

  const getHeaderTranslation = header => {
    // se trata cada traduccion en particular para cada th
    const headerTranslations = {
      titleRow: <span className='titleRow-container'>{t('panel.desempeno.table.header.metrics')}</span>,
      segmentAverage: t(`panel.desempeno.table.${comparisonType}`),
      difference: ' '
    };
    return headerTranslations[header] || t(`panel.desempeno.table.${header}`);
  };

  return (
    <TableLayout isMobile={isMobile}>
      <table cellSpacing={0}>
        <tbody>
          <tr className='headers'>
            {headers.map(header => {
              return (
                <Headers
                  key={header}
                  specialWidth={header === 'difference'}
                  data-panel={`comparisonTable-header-${header}`}
                >
                  {getHeaderTranslation(header)}
                  {header === 'segmentAverage' && comparisonType === 'better' && (
                    <HeaderTooltipContainer isMobile={isMobile}>
                      <InformativeTooltip dataPanel='info-better-performance' backgroundColor='black'>
                        <TooltipContent>{t('panel.desempeno.table.better.tooltip')}</TooltipContent>
                      </InformativeTooltip>
                    </HeaderTooltipContainer>
                  )}
                </Headers>
              );
            })}
          </tr>
          {rows.map(row => {
            return (
              <TableRow key={row.titleRow} data-panel={`container-comparisonTable-row-${row.titleRow}`}>
                {headers.map(header => {
                  return (
                    <TableData
                      key={header}
                      strong={header === 'myPost'}
                      className={hasHelper.includes(row.titleRow) && header === 'titleRow' ? 'withHelper' : ''}
                      data-panel={`comparisonTable-row-${header}`}
                    >
                      {(row.titleRow === 'price' || row.titleRow === 'priceByM2') && header === 'segmentAverage'
                        ? getPriceStatusLabel(header, row)
                        : getHeaderContent(header, row)}
                      {row.titleRow === 'visitsAndPrintsAvg' && header === 'titleRow' && (
                        <InformativeTooltip dataPanel='visits-porcent' backgroundColor='black'>
                          {t('panel.desempeno.table.visitsAndPrintsAvg.tooltip')}
                        </InformativeTooltip>
                      )}
                      {row.titleRow === 'visitsInterestedAvg' && header === 'titleRow' && (
                        <InformativeTooltip dataPanel='interested-porcent' backgroundColor='black'>
                          {t('panel.desempeno.table.visitsInterestedAvg.tooltip')}
                        </InformativeTooltip>
                      )}
                    </TableData>
                  );
                })}
              </TableRow>
            );
          })}
        </tbody>
      </table>
    </TableLayout>
  );
}

export default ComparisonTable;
